<template>
  <div class="main">
    <div class="image-container">
      <span class="help">帮助中心</span>
    </div>
    <div class="tab-container">
      <div class="tab">
        <ul class="clearfix">
          <li
            :class="{ actived: item.selected }"
            @click="clickTab(item)"
            v-for="item in tabs"
            :key="item.path"
          >
            <div class="title">
              <img src="@/assets/home/icon.png" />{{ item.title }}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div style="min-height:500px;"></div>
    <problemCell v-for="i in 0" :key="i.index"></problemCell>
  </div>
</template>

<script>
import problemCell from "@/components/problem/problemCell";
export default {
  components: {
    problemCell
  },
  data() {
    return {
      tabs: [
        {
          path: "examinationtype",
          selected: true,
          title: "测评报名"
          // des: "题型丰富，轻松应对测评"
        },
        {
          path: "examinationexplain",
          selected: false,
          title: "考务组织"
          // des: "按部就班，标准化流程"
        },
        {
          path: "download",
          selected: false,
          title: "测评答题"
          // des: "官方发布，定期更新"
        },
        {
          path: "download",
          selected: false,
          title: "测评结果"
          // des: "官方发布，定期更新"
        }
      ]
    };
  },
  computed: {
    // actived() {
    //   return item => {
    //     // return this.$route.path.indexOf(item.name) != -1;
    //     return item.selected;
    //   };
    // }
  },
  methods: {
    clickTab(item) {
      this.tabs.forEach(tab => {
        tab.selected = false;
      });
      item.selected = true;
      // this.$router.push({ path: item.path });
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  text-align: center;
  .image-container {
    width: 100%;
    height: 128px;
    background: url("../assets/home/bg_banner02_index.png") no-repeat;
    background-size: 100% 100%;
    .help {
      display: inline-block;
      line-height: 128px;
      text-align: left;
      width: 1200px;
      font-size: 30px;
      color: #ffffff;
    }
  }
  .image-error {
    margin: 20px;
  }
}
.tab-container {
  background-color: #f7f8fa;
  margin: 0 auto;
  border-bottom: solid 1px #dedfe1;
  text-align: center;
  .tab {
    margin: 0 auto;
    width: 1200px;
    ul {
      li:nth-child(2) {
        border-left: solid 1px #dedfe1;
        border-right: solid 1px #dedfe1;
      }
      li:nth-child(3) {
        // border-left: solid 1px #dedfe1;
        border-right: solid 1px #dedfe1;
      }
      li {
        width: 300px;
        height: 48px;
        background-color: #f7f8fa;
        cursor: pointer;
        float: left;
        font-size: 16px;
        color: #333333;
        position: relative;
        text-align: center;
        .title {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 19px;
          font-size: 18px;
          color: #333333;
          line-height: 48px;
          padding: 25px 0 0 0;
          img {
            margin-right: 10px;
          }
        }
        .des {
          color: #999999;
          font-size: 14px;
          padding: 20px 0 0 0;
        }
        // img {
        //   position: absolute;
        //   left: 0;
        //   bottom: -10px;
        //   right: 0;
        // }
        &.actived,
        &:hover {
          background-color: #eeeeee;
          border-bottom: solid #f78b24 2px;
        }
      }
    }
  }
}
</style>
